import { axiosClient } from "@/lib/axiosClient";

export interface MainroomParticipantMatch {
    registration_id: number;
    participant_name: string;
    institution_name: string | null;
    is_presenter: boolean;
    conference_name: string | null;
}

export const lookupMainroomParticipant = async (email: string) => {
    const { data } = await axiosClient.post<{ status: string; data: MainroomParticipantMatch[] }>(
        "/public/mainroom/lookup-participant",
        { email }
    );
    return data.data;
};

export interface MainroomAttendPayload {
    attendance_code: string;
    category: "vip" | "registered" | "other_invitee";
    registration_id?: number;
    full_name?: string;
    email?: string;
    institution?: string;
}

export interface MainroomAttendResult {
    status: string;
    message: string;
    data: {
        full_name: string;
        category: string;
        eligible_for_certificate: boolean;
    };
}

export const submitMainroomAttendance = async (payload: MainroomAttendPayload) => {
    const { data } = await axiosClient.post<MainroomAttendResult>("/public/mainroom/attend", payload);
    return data;
};
